import React, { useEffect, useState } from 'react'
import { Sheet, SheetContent, Button } from '@shopflo/ui'
import { motion } from 'motion/react'
import { useLocale } from 'src/lib/hooks/useLocal'

const SHRINK_STYLE = (
  <style>{`@keyframes delhiveryShrinkWidth { from { width: 100%; } to { width: 0%; } }`}</style>
)

const PIN_EASE: [number, number, number, number] = [0.34, 1.56, 0.64, 1];

const MapIconPreview = () => (
  <svg width='88' height='88' viewBox='0 0 88 88' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#del_clip0)'>
      <rect width='88' height='88' rx='44' fill='#C5F0FB' />
      <path
        d='M92.9111 61.1934L1.70014 32.6963H-4.22724L-7.41895 90.1462L39.544 96.0735L92.9111 83.7629V61.1934Z'
        fill='url(#del_paint0)'
        stroke='white'
        strokeWidth='6'
      />
      <path d='M68.749 52.4775L45.1133 89.3777' stroke='white' strokeWidth='6' />
      <path
        d='M44 18C54.2102 18 62.4873 26.2771 62.4873 36.4873V38.7207C62.4872 42.5066 61.2892 46.1956 59.0645 49.2588L47.0283 65.8301C45.5337 67.8879 42.4663 67.8879 40.9717 65.8301L28.9355 49.2588C26.7108 46.1956 25.5128 42.5066 25.5127 38.7207V36.4873C25.5127 26.2771 33.7898 18 44 18ZM44 26.668C40.1713 26.668 37.0676 29.7719 37.0674 33.6006C37.0674 37.4294 40.1712 40.5332 44 40.5332C47.8288 40.5332 50.9326 37.4294 50.9326 33.6006C50.9324 29.7719 47.8287 26.668 44 26.668Z'
        fill='url(#del_paint3)'
        fillOpacity='0.1'
      />
    </g>
    <rect x='1' y='1' width='86' height='86' rx='43' stroke='black' strokeOpacity='0.1' strokeWidth='2' />
    <defs>
      <linearGradient id='del_paint0' x1='42.7461' y1='32.6963' x2='42.7461' y2='96.0735' gradientUnits='userSpaceOnUse'>
        <stop stopColor='#DAFFCF' />
        <stop offset='1' stopColor='#A1CF51' />
      </linearGradient>
      <linearGradient id='del_paint3' x1='44' y1='18' x2='54.5332' y2='18' gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0' />
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' />
      </linearGradient>
      <clipPath id='del_clip0'>
        <rect width='88' height='88' rx='44' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

const FadedMapPreview = () => (
  <svg width='88' height='88' viewBox='0 0 88 88' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#del_faded_clip0)'>
      <rect width='88' height='88' rx='44' fill='#E7E7E7' />
      <path
        d='M44 18C54.2102 18 62.4873 26.2771 62.4873 36.4873V38.7207C62.4872 42.5066 61.2892 46.1956 59.0645 49.2588L47.0283 65.8301C45.5337 67.8879 42.4663 67.8879 40.9717 65.8301L28.9355 49.2588C26.7108 46.1956 25.5128 42.5066 25.5127 38.7207V36.4873C25.5127 26.2771 33.7898 18 44 18ZM44 26.668C40.1713 26.668 37.0676 29.7719 37.0674 33.6006C37.0674 37.4294 40.1712 40.5332 44 40.5332C47.8288 40.5332 50.9326 37.4294 50.9326 33.6006C50.9324 29.7719 47.8287 26.668 44 26.668Z'
        fill='url(#del_faded_paint2)'
        fillOpacity='0.1'
      />
    </g>
    <rect x='1' y='1' width='86' height='86' rx='43' stroke='black' strokeOpacity='0.05' strokeWidth='2' />
    <defs>
      <linearGradient id='del_faded_paint2' x1='44' y1='18' x2='54.5332' y2='18' gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0' />
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' />
      </linearGradient>
      <clipPath id='del_faded_clip0'>
        <rect width='88' height='88' rx='44' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

const PinIconPreview = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='37' height='50' viewBox='0 0 37 50' fill='none'>
    <path
      d='M18.4873 0C28.6975 1.13389e-05 36.9746 8.27707 36.9746 18.4873V20.7207C36.9746 24.5066 35.7765 28.1956 33.5518 31.2588L21.5156 47.8301C20.021 49.8879 16.9536 49.8879 15.459 47.8301L3.42285 31.2588C1.19807 28.1956 5.87996e-05 24.5066 0 20.7207V18.4873C0 8.27706 8.27706 0 18.4873 0ZM18.4873 8.66797C14.6586 8.66797 11.5549 11.7719 11.5547 15.6006C11.5547 19.4294 14.6585 22.5332 18.4873 22.5332C22.3161 22.5332 25.4199 19.4294 25.4199 15.6006C25.4198 11.7719 22.316 8.66797 18.4873 8.66797Z'
      fill='url(#del_pin_paint0)'
    />
    <path
      d='M18.4873 0C28.6975 1.13389e-05 36.9746 8.27707 36.9746 18.4873V20.7207C36.9746 24.5066 35.7765 28.1956 33.5518 31.2588L21.5156 47.8301C20.021 49.8879 16.9536 49.8879 15.459 47.8301L3.42285 31.2588C1.19807 28.1956 5.87996e-05 24.5066 0 20.7207V18.4873C0 8.27706 8.27706 0 18.4873 0ZM18.4873 8.66797C14.6586 8.66797 11.5549 11.7719 11.5547 15.6006C11.5547 19.4294 14.6585 22.5332 18.4873 22.5332C22.3161 22.5332 25.4199 19.4294 25.4199 15.6006C25.4198 11.7719 22.316 8.66797 18.4873 8.66797Z'
      fill='url(#del_pin_paint1)'
      fillOpacity='0.5'
    />
    <path
      d='M18.4873 0C28.6975 1.13389e-05 36.9746 8.27707 36.9746 18.4873V20.7207C36.9746 24.5066 35.7765 28.1956 33.5518 31.2588L21.5156 47.8301C20.021 49.8879 16.9536 49.8879 15.459 47.8301L3.42285 31.2588C1.19807 28.1956 5.87996e-05 24.5066 0 20.7207V18.4873C0 8.27706 8.27706 0 18.4873 0ZM18.4873 8.66797C14.6586 8.66797 11.5549 11.7719 11.5547 15.6006C11.5547 19.4294 14.6585 22.5332 18.4873 22.5332C22.3161 22.5332 25.4199 19.4294 25.4199 15.6006C25.4198 11.7719 22.316 8.66797 18.4873 8.66797Z'
      fill='url(#del_pin_paint2)'
      fillOpacity='0.1'
    />
    <defs>
      <linearGradient id='del_pin_paint0' x1='18.4873' y1='0' x2='18.4873' y2='21.6051' gradientUnits='userSpaceOnUse'>
        <stop stopColor='#888888' />
        <stop offset='1' stopColor='#222222' />
      </linearGradient>
      <linearGradient id='del_pin_paint1' x1='-0.566431' y1='1.04585' x2='9.52859' y2='20.4133' gradientUnits='userSpaceOnUse'>
        <stop stopColor='#0099C0' />
        <stop offset='1' stopColor='#0099C0' stopOpacity='0' />
      </linearGradient>
      <linearGradient id='del_pin_paint2' x1='18.4873' y1='0' x2='29.0205' y2='0' gradientUnits='userSpaceOnUse'>
        <stop stopColor='white' stopOpacity='0' />
        <stop stopColor='white' />
        <stop offset='1' stopColor='white' />
      </linearGradient>
    </defs>
  </svg>
)

interface DelhiveryConfirmationSheetProps {
  open: boolean
  onOpenChange?: (open: boolean) => void
  container: HTMLElement | null
  duration?: number
  primaryColor?: string
  primaryTextColor?: string
}

const DelhiveryConfirmationSheet: React.FC<DelhiveryConfirmationSheetProps> = ({
  open,
  onOpenChange,
  container,
  duration = 3,
  primaryColor = '#18181B',
  primaryTextColor = '#FFFFFF'
}) => {
  const { t } = useLocale()
  const [pinLanded, setPinLanded] = useState(false)

  useEffect(() => {
    if (!open) {
      setPinLanded(false)
      return
    }
    const fallback = setTimeout(() => setPinLanded(true), 1500)
    return () => clearTimeout(fallback)
  }, [open])

  useEffect(() => {
    if (!open || !pinLanded) return
    const timer = setTimeout(() => onOpenChange?.(false), duration * 1000)
    return () => clearTimeout(timer)
  }, [open, pinLanded, duration])

  return (
    <Sheet open={open}  modal={false}>
      <SheetContent
        side='bottom'
        container={container}
        withinContainer
        style={{
          background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.10) 2.38%, #FFF 73.31%)',
          backdropFilter: 'blur(1.5px)'
        }}
        className='!h-full !overflow-y-auto !border-0 !mt-auto'
        overlayClassName='!bg-transparent'
      >
        {SHRINK_STYLE}
        <div className='flex flex-1 flex-col items-center justify-end w-full h-full pb-8'>
          <div className='relative mb-4 inline-flex items-center justify-center overflow-hidden'>
            <div className='relative'>
              <motion.div
                initial={{ opacity: 1 }}
                animate={{ opacity: pinLanded ? 0 : 1 }}
                transition={{ duration: 3, ease: 'linear' }}
              >
                <MapIconPreview />
              </motion.div>
              <motion.div
                className='absolute inset-0'
                initial={{ opacity: 0 }}
                animate={{ opacity: pinLanded ? 1 : 0 }}
                transition={{ duration: 3, ease: 'linear' }}
              >
                <FadedMapPreview />
              </motion.div>
            </div>
            <motion.div
              className='absolute inset-0 flex items-center justify-center'
              initial={{ opacity: 0, y: 32, scale: 0.8 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ duration: 0.45, ease: PIN_EASE, delay: 0.2 }}
              onAnimationComplete={() => setPinLanded(true)}
            >
              <PinIconPreview />
            </motion.div>
          </div>

          <div className='flex flex-col items-center gap-2 w-[18.5rem] mb-8'>
            <p className='text-text-md-bold text-zinc-900'>Delivering to</p>
            <div className='flex items-center justify-center rounded-lg bg-black/[0.04] px-1.5'>
              <p className='text-text-sm-semibold text-zinc-600'>Home</p>
            </div>
            <p className='text-text-sm-medium text-zinc-900 text-center opacity-70 line-clamp-2'>
              Rajan Mehta · 123, MG Road, Bengaluru, Karnataka 560001
            </p>
          </div>

          <div className='w-full px-6'>
            <div className='relative overflow-hidden rounded-xl'>
              <Button
                variant='ghost'
                size='xl'
                className='w-full   !rounded-lg'
                style={{ background: primaryColor, color: primaryTextColor }}
              >
                {t('delhivery_confirmation_popup_btn_text')}
              </Button>
              {pinLanded && (
                <div
                  className='absolute top-0 right-0 h-full w-full bg-white opacity-20 pointer-events-none'
                  style={{ animation: `delhiveryShrinkWidth ${duration}s linear forwards` }}
                />
              )}
            </div>
          </div>
          <div className='w-full px-6 mt-2'>
            <Button
              variant='ghost'
              size='xl'
              className='w-full border border-black/5 !rounded-lg hover:!bg-transparent'
              style={{ color: primaryColor }}
              onClick={() => onOpenChange?.(false)}
            >
              {t('skip')}
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  )
}

export default DelhiveryConfirmationSheet
